import { render, staticRenderFns } from "./RegDocUpdateTips.vue?vue&type=template&id=72b207a4&scoped=true&"
import script from "./RegDocUpdateTips.vue?vue&type=script&lang=js&"
export * from "./RegDocUpdateTips.vue?vue&type=script&lang=js&"
import style0 from "./RegDocUpdateTips.vue?vue&type=style&index=0&id=72b207a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b207a4",
  null
  
)

export default component.exports